import axios from 'axios'
import Configuration from '../config/configuration';

class CalculatorService {

    constructor() {
        this.config = new Configuration();
    }

    addFinance(formData) {
        return axios.post(this.config.apiBaseUrl + 'finance-banks', formData);
    }
    getFinance() {
        return axios.get(this.config.apiBaseUrl + 'finance-banks');
    }
    deleteFinance(id) {
        return axios.delete(this.config.apiBaseUrl + 'finance-banks?id=' + id);
    }
    updateFinance(formData, id) {
        return axios.put(this.config.apiBaseUrl + `finance-banks?id=${id}`, formData);
    }
  

  
}

export default CalculatorService;
